(function ( $ ) {
     $.fn.ajaxWishList = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink      = $(this);

        function _init() {
            objLink.each(function (index) {
                _clickProduct($(this));
            });
        }

        function _performacncebtn(o){
            if($(o).find('i').hasClass('active')){
                $(o).find('i').removeClass('active');
            }else{
                $(o).find('i').addClass('active');
            }

        }

        function _clickProduct(o){
            $(o).click(function() {
                _performacncebtn(o);
                _doWishList(o);
            });
        }

        function _doWishList(o){
            $.ajax({
                url : ajaxurl,
                data : {
                            'action': 'add_wish_list',
                            'ids': $(o).attr("data-id"),
                        },
                type : 'POST',
                success : function( data ){
                    if(data.status != null){
                        console.log(data.status);
                    }
                }
            });
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$('a.addWishList').ajaxWishList();
